module.exports = __webpack_public_path__ + "img/hyu_gallery11.bee2d26d.jpg";